export default {
  title01: "Tempo Atual",
  title02: "24 Horas",
  title03: "Ver previsão do tempo para 10 dias",
  title04: "AQI",
  title05: "Ver todas as informações",
  title06: "Nascer e pôr do sol",
  title07: "Fase da lua",
  title08: "Próxima lua cheia",
  title09: "Próxima lua nova",
  title10: "DIA",
  title11: "NOITE",
  title12: "Nascer do Sol",
  title13: "Pôr do Sol",
  title14: "Nascer da Lua",
  title15: "Pôr da Lua",
  title16: "Fonte",
  title17: "Início",
  title18: "Fim",
  title19: "Usar localização atual",
  title20: "Pesquisar a cidade",
  title21: "Sensação Térmica",
  title22: "Sensação Térmica na Sombra",
  title23: "Agora",
  title24: "Hoje",
  title25: "DOM",
  title26: "SEG",
  title27: "TER",
  title28: "QUA",
  title29: "QUI",
  title30: "SEX",
  title31: "SÁB",
  title32: "Carregando...",
  title33: "Agora",
  title34: "Por Hora",
  title35: "Diário",
  title36: "Sol & lua",
  title37: "Qualidade do ar",
  title38: "Contato: xlf550402@gmail.com",
  title39: "Acordo de Privacidade",
  title40: "Direitos Autorais © comfortweather.com 2020 - 2025. Todos os Direitos Reservados.",
  title41: "Dados fornecidos por",
  title42: "Al",
  title43: "Bai",
  title44: "Aceitar",
  title45:
    "Obrigado por usar o ComfortWeather! Para proteger melhor seus direitos e interesses legais, leia atentamente a ",
  title46: "Política de Privacidade",
  title47: " antes de usar.",
  title48: "",
  title49: "Contato: xyjph123@gmail.com",
  title50: "Direitos Autorais © 24hweather.com 2020 - 2025. Todos os Direitos Reservados.",
  title51: "Obrigado por usar o 24hweather! Para proteger melhor seus direitos e interesses legais, leia atentamente a ",
};
